(() => {
    // Catches every cart mutation on the page — our own AJAX add-to-cart
    // forms, but also Rebuy's own remove/quantity-change buttons inside
    // its drawer, which we have no direct hook into otherwise. Rebuy calls
    // Shopify's standard /cart/* endpoints under the hood, so patching
    // fetch once here covers all of it without each add-to-cart
    // implementation needing to remember to dispatch the event itself.
    const CART_MUTATION_PATTERN = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    if (!window.__campaignCartFetchPatched) {
        window.__campaignCartFetchPatched = true;
        const originalFetch = window.fetch;
        window.fetch = function (...args) {
            const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
            const isMutation = CART_MUTATION_PATTERN.test(url);
            const result = originalFetch.apply(this, args);
            if (isMutation) {
                result.then(() => {
                    window.dispatchEvent(new CustomEvent('campaign:cart-updated'));
                }).catch(() => {});
            }
            return result;
        };
    }

    function refreshBadge(root) {
        const badge = root.querySelector('[data-cart-icon-badge]');
        if (!badge) return;
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(r => r.json())
            .then(cart => {
                if (cart.item_count > 0) {
                    badge.textContent = cart.item_count > 99 ? '99+' : cart.item_count;
                    badge.style.display = 'flex';
                } else {
                    badge.style.display = 'none';
                }
            })
            .catch(() => {});
    }

    function openRebuyDrawer() {
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
            window.Rebuy.SmartCart.show();
            return;
        }
        let attempts = 0;
        const wait = setInterval(() => {
            attempts++;
            if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
                clearInterval(wait);
                window.Rebuy.SmartCart.show();
            } else if (attempts >= 10) {
                clearInterval(wait);
                console.error('campaign-cart-icon: Rebuy.SmartCart was not available after waiting.');
            }
        }, 200);
    }

    document.querySelectorAll('[data-cart-icon]').forEach(root => {
        if (!root.hasAttribute('data-use-rebuy-drawer')) return;
        refreshBadge(root);
        const btn = root.querySelector('[data-cart-icon-button]');
        if (btn) btn.addEventListener('click', openRebuyDrawer);
        window.addEventListener('campaign:cart-updated', () => refreshBadge(root));
    });
})();
